import {
  isSchedulePreferenceUserId,
  readSchedulePreferences,
  updateSchedulePreferences,
} from './schedulePreferencesStorage'

const cleanIds = (value: unknown): number[] => {
  if (!Array.isArray(value)) return []
  const ids: number[] = []
  const seen = new Set<number>()
  for (const entry of value) {
    const id = Number(entry)
    if (!Number.isInteger(id) || id < 0 || seen.has(id)) continue
    seen.add(id)
    ids.push(id)
  }
  return ids
}

export const getScheduleDoctorRailOrder = (userId: number | null | undefined): number[] => {
  if (!isSchedulePreferenceUserId(userId)) return []
  return cleanIds(readSchedulePreferences()[String(userId)]?.doctorRailOrder)
}

export const setScheduleDoctorRailOrder = (
  userId: number | null | undefined,
  orderedIds: number[],
): number[] => {
  const next = cleanIds(orderedIds)
  if (!isSchedulePreferenceUserId(userId)) return next
  updateSchedulePreferences(userId, (current) => ({ ...current, doctorRailOrder: next }))
  return next
}
